<template>
    <div class="bg-light">
        <div class="container space-2">
            <div class="row">
                <div class="col-lg-3 mb-7 mb-lg-0">
                    <!-- Profile Card -->
                    <div class="card p-1 mb-4">
                        <div class="card-body text-center">
                            <div class="mb-3">
                                <img class="u-lg-avatar rounded-circle"
                                     :src="avatarDisplayUrl" alt="Image Description">
                            </div>

                            <div class="mb-3">
                                <h1 class="h6 font-weight-medium mb-0"> {{ userInfo.profile.displayName }} </h1>
                                <small class="d-block text-muted">{{ userInfo.profile.profession }}</small>
                            </div>
                        </div>
                    </div>
                    <!-- End Profile Card -->

                    <!-- Social Profiles -->
                    <div v-if="socialLinkCount !== 0" class="card mb-4">
                        <div class="card-header pt-4 pb-3 px-0 mx-4">
                            <h3 class="h6 mb-0">Réseaux sociaux</h3>
                        </div>

                        <div class="card-body pt-3 pb-4 px-4">
                            <!-- Social Profiles -->
                            <a class="media mb-4" v-if="userInfo.profile.twitterLink"
                               v-bind:href="userInfo.profile.twitterLink" target="_blank">
                                <div class="u-sm-avatar mr-3">
                                    <img class="img-fluid" src="../../public/assets/img/160x160/img19.png"
                                         alt="Image Description">
                                </div>
                                <div class="media-body">
                                    <span class="d-block text-dark">Twitter</span>
                                    <small class="d-block text-secondary"></small>
                                </div>
                            </a>
                            <!-- End Social Profiles -->

                            <!-- Social Profiles -->
                            <a class="media" v-if="userInfo.profile.facebookLink" v-bind:href="userInfo.profile.facebookLink" target="_blank">
                                <div class="u-sm-avatar mr-3">
                                    <img class="img-fluid" src="../../public/assets/img/160x160/img20.png" alt="Image Description">
                                </div>
                                <div class="media-body">
                                    <span class="d-block text-dark">Facebook</span>
                                    <small class="d-block text-secondary"></small>
                                </div>
                            </a>
                            <!-- End Social Profiles -->
                        </div>
                    </div>
                    <!-- End Social Profiles -->
                </div>

                <div class="col-lg-9">
                    <!-- User Details -->
                    <div class="mb-4">
                        <h2 class="h4">Salut, moi c'est {{ userInfo.profile.displayName }}
<!--                          <span class="badge badge-success ml-1">Pro</span>-->
                        </h2>
                        <h4 class="h6 text-secondary mb-0"> {{ userInfo.profile.location }} <small>- A joint le {{ dateJoined }} </small></h4>
                    </div>
                    <!-- End User Details -->

                    <!-- Info -->
                    <div class="mb-4">
                        <p> {{ userInfo.profile.biography }} </p>
                    </div>
                    <!-- End Info -->

                    <hr class="my-7">

                    <!-- Icon Blocks -->
                    <div class="row">
                        <div class="col-md-6 col-lg-4">
                            <!-- List Group -->
                            <ul class="list-group list-group-transparent list-group-flush list-group-borderless mb-0">
                                <li class="list-group-item pt-0 pb-4">
                                    <div class="media">
                                        <span class="fas fa-mobile-alt list-group-icon mr-3"></span>
                                        <div class="media-body text-lh-sm">
                                            <span class="d-block mb-1">Num téléphone:</span>
                                            <span class="d-block text-muted">{{ userInfo.profile.phoneNumber }}</span>
                                        </div>
                                    </div>
                                </li>
                                <li class="list-group-item pt-0 pb-4">
                                    <div class="media">
                                        <span class="fas fa-link list-group-icon mr-3"></span>
                                        <div class="media-body text-lh-sm">
                                            <span class="d-block mb-1">Url siteweb:</span>
                                            <a v-bind:href="userInfo.profile.websiteUrl" target="_blank">
                                                {{ userInfo.profile.websiteUrl }}
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <!-- End List Group -->
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <!-- List Group -->
                            <ul class="list-group list-group-transparent list-group-flush list-group-borderless mb-0">
                                <li class="list-group-item pt-0 pb-4">
                                    <div class="media">
                                        <span class="fas fa-birthday-cake list-group-icon mr-3"></span>
                                        <div class="media-body text-lh-sm">
                                            <span class="d-block mb-1">Date d'anniversaire:</span>
                                            <span class="d-block text-muted">{{ userInfo.profile.birthday }}</span>
                                        </div>
                                    </div>
                                </li>
                                <li class="list-group-item pt-0 pb-4">
                                    <div class="media">
                                        <span class="fas fa-building list-group-icon mr-3"></span>
                                        <div class="media-body text-lh-sm">
                                            <span class="d-block mb-1">Lieu de travail:</span>
                                            <span class="d-block text-muted">{{ userInfo.profile.workplace }}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <!-- End List Group -->
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <!-- List Group -->
                            <ul class="list-group list-group-transparent list-group-flush list-group-borderless mb-0">
                                <li class="list-group-item pt-0 pb-4">
                                    <div class="media">
                                        <span class="fas fa-map-marker-alt list-group-icon mr-3"></span>
                                        <div class="media-body text-lh-sm">
                                            <span class="d-block mb-1">Location:</span>
                                            <span class="d-block text-muted">{{ userInfo.profile.location }}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <!-- End List Group -->
                        </div>
                    </div>
                    <!-- End Icon Blocks -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ASSETS_FOLDER} from "../settings";
    import {moment} from "../xlib";

    export default {
        name: "ViewProfileInfo",
        props: ["userInfo"],
        computed: {
            dateJoined: function (){
                return moment(this.userInfo.dateJoined).format('LLL');
            },
            socialLinkCount: function () {
                let result = 0;
                if(this.userInfo.profile.twitterLink){
                    result += 1;
                }
                if(this.userInfo.profile.facebookLink){
                    result += 1;
                }
                return result;
            },
            avatarDisplayUrl: function () {
                let avatarUrl = this.userInfo.profile.avatarUrl;
                return avatarUrl ? avatarUrl : `${ASSETS_FOLDER}/img/160x160/anonymous_user.png`
            }
        }
    }
</script>

<style scoped>

</style>